module.exports = __webpack_public_path__ + "static/media/DecMobile.catalyst.e330bc44.tsx";